export default __webpack_public_path__ + "33b34daa86210aea42c7568e085ba894.svg";